import React, { FormEvent, useState } from 'react'
import { toast } from 'react-toastify'

import { getRecordsByPhone, deleteSupplierRecords, toastSuccess } from '../../../api'
import { JsonRecord, Record } from '../../../models'
import { getAuthUser } from '../../../helpers'
import defineAbilityFor from '../defineAbility'
import { InsufficientPermissions, PaginatedTable, PaginatedTableCallbacks } from '../../common';
import { RecordsTable } from './../collectionTable'
import Axios from 'axios'

export const DeleteRecordsLanding = () => {
    const ability = defineAbilityFor(getAuthUser())

    const [phone, setPhone] = useState('')
    const [searchPhone, setSearchPhone] = useState('')
    const [showTable, setShowTable] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    
    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
    
        const trimmed = phone.trim()
        if (!trimmed) {
            toast.warn('Please enter a valid phone number')
            return
        }
    
        setSearchPhone(trimmed)
        setShowTable(true)
    }
    
    const deleteRecords = async (phone: string) => {
        setIsDeleting(true)
        try {
            const response = await getRecordsByPhone({ search: phone })

            if (response.data?.data?.length === 0) {
                toast.warn('No records found for this phone number')
                setPhone('')
                return
            }

            const deleteResponse = await deleteSupplierRecords(phone)

            if (deleteResponse?.status === 200) {
                toastSuccess('Records Deleted')
                setPhone('')
                setShowTable(false)
            }
    
        } catch (error: any) {
            if (Axios.isAxiosError(error) && error.response) {
                const { response } = error
                const message =
                    typeof response.data === 'string'
                        ? response.data
                        : response.data?.message || 'Bad Request'

                switch (response.status) {
                    case 400:
                        toast.error(`Error 400: ${message}`, {autoClose: false})
                        break
                    case 403:
                        toast.error('Executive permissions required to delete records', {
                            autoClose: false
                        })
                        break
                    default:
                        toast.error(`An unknown error occurred: ${message}`)
                        console.error(error)
                }
            } else {
                toast.error('An error occurred while deleting records')
                console.error(error)
            }
        } finally {
            setIsDeleting(false)
        }
    }

    if (!ability.can('Delete', 'Record')) {
        return <InsufficientPermissions />
    }

    return (
        <>
            <div className='container'>
                <div className='row d-flex justify-content-center'>
                    <div className='col-xs-12 col-md-3'>
                        <h3>Search for Record</h3>
                        <form onSubmit={handleSubmit}>
                            <input
                                className='form-control mb-3'
                                onChange={(e) => setPhone(e.target.value)}
                                placeholder='Phone'
                                type='text'
                                value={phone}
                            />
                            <div className='flex mb-4'>
                                <button className='btn btn-primary' type='submit'>
                                    Find Records
                                </button>
                                {showTable && (
                                    <button
                                        disabled={!phone || isDeleting}
                                        className='btn btn-danger ms-2'
                                        onClick={() => {
                                                if (window.confirm(`Are you sure you want to delete all records for ${phone}?`)) {
                                                    deleteRecords(phone)
                                                }
                                            }}>
                                        {isDeleting ? (
                                            <>
                                                <span
                                                    className='spinner-border spinner-border-sm'
                                                    role='status'
                                                    aria-hidden='true'
                                                ></span>
                                                Deleting...
                                            </>
                                        ) : (
                                            'Delete'
                                        )}
                                    </button>
                                )}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {showTable && (
                <PaginatedTable<Record, JsonRecord>
                    key={searchPhone}
                    disableSearch={true}
                    getData={(params) => getRecordsByPhone({ ...params, search: searchPhone })}
                    modelConstructor={(json: JsonRecord) => new Record(json)}
                    Table={(
                        records: Record[], 
                        callbacks: PaginatedTableCallbacks
                    ) => (
                        <RecordsTable 
                        callbacks={callbacks} 
                        resources={{ records }} 
                        />
                    )}
                    title="Records to Delete"
                />
            )}
        </>
    )
}
